import { useEffect } from 'react';

const scrollToElement = (name) => {
  let elements = document.getElementsByClassName(name);
  if (!elements || elements.length === 0) {
    elements = document.getElementsByClassName('ant-form-explain');
  }
  if (elements && elements.length > 0) {
    const elementosArray = Array.from(elements);
    elementosArray.sort((a, b) => b.scrollHeight - a.scrollHeight);
    elements[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }
};

export const useScrollToError = ({
  overwriteChangeDetection = false, hasErrors = false, errors = {}, errorClassName = 'errors',
}) => {
  useEffect(() => {
    if (!overwriteChangeDetection && (hasErrors || Object.keys(errors).length > 0)) {
      scrollToElement(errorClassName);
    }
  }, [hasErrors, errors]);

  return (hasErrors2 = false) => {
    (hasErrors2 || hasErrors || Object.keys(errors).length > 0) && scrollToElement(errorClassName);
  };
};
